





































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IInterestStep } from '@/app/interest-charge-process';

const STATE_ICONS: Record<string, string | null> = {
  done: 'check',
  actionable: 'exclamation',
  waiting: 'clock',
  idle: null,
};

// A charging interest invoice can be held back for more reasons than a payment
// reminder can, so the waiting circle explains which one applies rather than
// always naming a date.
const REASONS_WITHOUT_DATE = [ 'nothing_to_charge', 'feature_disabled' ];

@Component
export default class InterestChargeProcess extends Vue {
  @Prop({ required: true }) private steps!: IInterestStep[];

  private stepIcon(step: IInterestStep): string | null {
    return STATE_ICONS[step.state];
  }

  private stepTitle(step: IInterestStep): string {
    return this.$t(`Invoice.InterestCharge.Process.Step.${step.key}`) as string;
  }

  private stepExplanation(step: IInterestStep): string {
    // Translation scopes are PascalCase, entries are the dynamic state.
    const scope = step.key.charAt(0).toUpperCase() + step.key.slice(1);
    let state: string = step.state;

    if (step.state === 'waiting' && step.blockedReason && REASONS_WITHOUT_DATE.includes(step.blockedReason)) {
      state = step.blockedReason;
    }

    return this.$t(
      `Invoice.InterestCharge.Process.Explanation.${scope}.${state}`,
      { date: step.availableFrom },
    ) as string;
  }
}
